import * as yup from 'yup';
import { EditorState } from 'draft-js';

import { MAX_APPLY_MESSAGE_TEXTAREA_LENGTH } from 'src/enums/Validation';
import { convertToHtmlFormat, getRawTextEditorValue } from 'src/utils/textEditor';
import { TalentOpportunityApplyInfo } from 'src/features/opportunities/types/talentOpportunityApply';

import { WYSIWYG_NOT_EMPTY } from '../customRules';

export type OpportunityApplyFormData = {
  skillsAndQualifications: EditorState;
  experience: EditorState;
  applyMessage: EditorState;
};

export type OpportunityApplyFormDataToSubmit = TalentOpportunityApplyInfo;

const fieldValidation = yup
  .mixed()
  .test(WYSIWYG_NOT_EMPTY)
  .test({
    test: (state: EditorState) => getRawTextEditorValue(state).length <= MAX_APPLY_MESSAGE_TEXTAREA_LENGTH,
    message: 'You cannot use more then 2,500 characters',
  })
  .default(EditorState.createEmpty());

export const validationFields = {
  skillsAndQualifications: fieldValidation,
  experience: fieldValidation,
  applyMessage: fieldValidation,
};

export const validationSchema = yup.object(validationFields);

export const initialValues: OpportunityApplyFormData = validationSchema.getDefault();

export const attributesToSubmit = (formData: OpportunityApplyFormData): OpportunityApplyFormDataToSubmit => {
  return {
    skillsAndQualifications: convertToHtmlFormat(formData.skillsAndQualifications),
    experience: convertToHtmlFormat(formData.experience),
    applyMessage: convertToHtmlFormat(formData.applyMessage),
  };
};
